export default {"src":"/_next/static/media/taskTracker.7f418345.svg","height":42,"width":116};